export const GAME_CAST_REQUEST_TIMEOUT = 4 * 60 * 1000;
